import {
  TERMS_OF_SERVICES,
  PRIVACY_POLICY,
  ASSETRON_MARKETING_SITE_CONTACT_US_URL,
} from '@assetron/common/constants/constant';
import { useTheme } from '@mui/material';
import { useMemo } from 'react';
import useDesignTokens from '../../../themes/useDesignTokens';

const useAssetronFooterStyles = () => {
  const theme = useTheme();
  const tokens = useDesignTokens();

  const styles = useMemo(() => {
    const footerLinkStyle = {
      color: tokens.colors.text.secondary,
      textDecoration: 'none !important',
      '&:hover': {
        textDecoration: 'none !important',
        color: tokens.components.button.link.default.fg.hover,
      },
      [theme.breakpoints.down('sm')]: {
        padding: theme.sizeGuide.none,
      },
    };

    return {
      footerDimensions: {
        width: '100vw',
        height: theme.sizeGuide['8xl'],
        display: 'flex',
        alignItems: 'center',
        [theme.breakpoints.down('sm')]: {
          height: 'auto',
        },
      },
      footerContentStyle: {
        width: 'inherit',
        paddingLeft: theme.sizeGuide['8xl'],
        paddingRight: theme.sizeGuide['8xl'],
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        color: tokens.colors.text.secondary,

        [theme.breakpoints.down('sm')]: {
          padding: `${theme.sizeGuide['3xl']} ${theme.sizeGuide.none}`,
          flexDirection: 'column',
          textAlign: 'center',
          gap: theme.sizeGuide['3xl'],
        },
      },

      copyrightPadding: {
        paddingLeft: theme.sizeGuide['4xl'],
        [theme.breakpoints.down('sm')]: {
          padding: theme.sizeGuide.none,
          textAlign: 'center',
        },
      },

      footerLinksContainerStyle: {
        display: 'flex',
        flexDirection: 'row',
        gap: theme.sizeGuide.xl,
        paddingRight: theme.sizeGuide['4xl'],
        [theme.breakpoints.down('sm')]: {
          padding: `${theme.sizeGuide.none} ${theme.sizeGuide.xl}`,
          justifyContent: 'center',
          gap: theme.sizeGuide.md,
          columnGap: theme.sizeGuide.xl,
          flexWrap: 'wrap',
        },
      },

      footerLinkStyle,

      primaryFooterLinkStyle: {
        ...footerLinkStyle,
        color: tokens.colors.text.highlight.primary,
      },

      contactUsLink: ASSETRON_MARKETING_SITE_CONTACT_US_URL,
      termsOfServiceLink: TERMS_OF_SERVICES,
      privacyPolicyLink: PRIVACY_POLICY,
    };
  }, [theme, tokens]);

  return styles;
};

export default useAssetronFooterStyles;
